export const FETCH_ALL_USER_REQUESTED = 'FETCH_ALL_USER_REQUESTED';
export const FETCH_ALL_USER_SUCCEEDED = 'FETCH_ALL_USER_SUCCEEDED';
export const DELETE_USER_REQUESTED = 'DELETE_USER_REQUESTED';
export const DELETE_USER_SUCCEEDED = 'DELETE_USER_SUCCEEDED';
export const FILTER_USERS_REQUESTED = 'FILTER_USERS_REQUESTED';
export const FILTER_USERS_SUCCEEDED = 'FILTER_USERS_SUCCEEDED';
export const FILTER_USERS_PROCESSING = 'FILTER_USERS_PROCESSING';
export const IMPERSONATE_STARTED = 'IMPERSONATE_STARTED';
export const IMPERSONATE_SUCCEEDED = 'IMPERSONATE_SUCCEEDED';
export const IMPERSONATE_COMPLETED = 'IMPERSONATE_COMPLETED';
